import { z } from 'zod';

export const emptyStringToHyphenSchema = z
  .string()
  .transform((value) => value.trim() || '-');

export const emptyStringToNullSchema = z
  .string()
  .transform((value) => (value.trim() === '' ? null : value));

export function validOrFallback<Input, Output>(
  maybe: z.SafeParseReturnType<Input, Output>,
  fallback: Output
): Output {
  return maybe.success ? maybe.data : fallback;
}
